export class Tag {
  tagID: number;
  name: string;
  description: string;
}
